
// DEPENDENCIES
import React, { useEffect, useState } from 'react';
// COMPONENTS
import MUIDataTable from "mui-datatables";
// ICONS
// CUSTOM COMPONENTS
import FormBlock from '../../../../../components/FormBlock';
import Section from '../../../../../components/Section';
import ContentBlock from '../../../../../components/ContentBlock';
import CustomBlock from '../../../../../components/CustomBlock';
import ContentHeader from '../../../../../components/ContentHeader';
import InputBlock from '../../../../../components/InputBlock';
import TextAreBlock from '../../../../../components/TextAreBlock';
import ModalBlock from '../../../../../components/ModalBlock';
import Button from '../../../../../components/Button';
// SERVICES AND HELPERS

const TCLPRCRA8SurveyDataSheet = (props) => {

    const [confirmDeleteModalVisible, setConfirmDeleteModalVisible] = useState(false);
    const [unit, setUnit] = useState('mg/L')

    const columnOptions = {
        filter: true,
        sort: true,
        print: false,
        download: true
    };

    const options = {
        selectableRows: "none",
        download: true,
        print: false,

    };

    const data = [
        ['', 'LW-01', '108 Business Park Ave, Ste A, Denham Springs LA, 70726', '10'],
    ];

    const columns = [
        {
            name: "id",
            label: "Actions",
            options: {
                filter: false,
                sort: false,
                print: false,
                download: false,
                customBodyRenderLite: () => {
                    return (
                        <CustomBlock className="content-container--actions flex-start pl-0 mt-0">
                            <Button
                                text="Edit"
                                className="info--bg ml-0"
                                size="xxs"
                                to="/job/po/material/edit/:0"
                            />

                            <Button
                                text="Delete"
                                className="danger--bg"
                                size="xxs"
                                onClick={() => setConfirmDeleteModalVisible(true)}
                            />
                        </CustomBlock>
                    )
                }
            }

        },
        {
            name: "sampleNumber",
            label: "Sample No.",
            options: columnOptions
        },
        {
            name: "location",
            label: "Location",
        },
        {
            name: "results",
            label: `Results ${unit}`,
        },
    ];

    return (
        <>
            <Section removeContainer className="pt-10 pb-10 border-top">
                <ContentBlock>
                    <ContentHeader
                        title="Line Item Entry"
                        headerSize="sm"
                        className="fw-700 pb-15"
                        primaryButtonText="Add Line Item"
                    />
                </ContentBlock>

                <ContentBlock cols={2}>
                    <InputBlock
                        label="Sample No."
                    />
                </ContentBlock>

                <ContentBlock cols={8}>
                    <InputBlock
                        label="Location"
                    />
                </ContentBlock>

                <ContentBlock cols={2}>
                    <InputBlock
                        label={`Results (${unit})`}
                    />
                </ContentBlock>

                <ContentBlock>
                    {/* LINE ITEMS TABLE */}
                    <CustomBlock className="content-container--table-container">
                        <ContentHeader
                            title="Samples Line Items"
                            headerSize="md"
                            className="fw-700 dark-grey--clr pt-10"
                        />

                        <MUIDataTable
                            data={data}
                            columns={columns}
                            options={options}
                        />
                    </CustomBlock>
                </ContentBlock>
            </Section>

            {/* CONFIRM DELETE MODAL */}
            <ModalBlock
                show={confirmDeleteModalVisible}
                contentHeader="Delete Line Item"
                onHide={() => setConfirmDeleteModalVisible(false)}
                closeAction
                centered
                contentDescription="Are you sure you want to delete this line item?"
                primaryModalActionOnClick={() => console.log("Deleting...")}
            />
        </>
    )
}

export default TCLPRCRA8SurveyDataSheet;